import { useKeycloak } from "@react-keycloak/web";
import React, { useContext } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import "./App.scss";
import ForgotPassword from "./containers/auth/ForgotPassword/ForgotPassword";
import { Unauthorized } from "./containers/Errors";
import Navigation from "./containers/Navigation/Navigation";
import Private from "./containers/Private/Private";
import ProtectedRoute from "./containers/Routing/ProtectedRoute";
import { AuthContext, User } from "./contexts/Auth/AuthContext";
import MessageModal from "./contexts/Message/MessageModal";
import API from "./services/API/index";

function App() {
    const { keycloak, initialized } = useKeycloak();
    const authContext = useContext(AuthContext);
    React.useEffect(() => {
        if (initialized) {
            if (keycloak.authenticated) {
                API.HandleGetRequest("/users/sync")
                    .then((res) => authContext.actions.setCoach(res as User))
                    .catch((err) => {
                        alert("Error while creating your user");
                    });
            }
        }
    }, [keycloak.authenticated, initialized]);
    if (!initialized) {
        return <></>;
    }
    if (!keycloak.authenticated) {
        keycloak.login();
        return <></>;
    }

    return (
        <div>
            <MessageModal />
            <Switch>
                <ProtectedRoute
                    authenticationPath="/not_authorized"
                    path={"/private"}
                >
                    <Private />
                </ProtectedRoute>
                <Route exact path="/not_authorized" component={Unauthorized} />
                <Route exact path="/private">
                    <Private />
                </Route>
                <Route exact path="/forgot_password">
                    <ForgotPassword />
                </Route>

                <ProtectedRoute
                    authenticationPath="/login"
                    path="/home"
                    component={Navigation}
                />
                <Redirect from="/" to="/home" />
            </Switch>
        </div>
    );
}

export default App;
